/* eslint-disable react-hooks/exhaustive-deps */

import { BILLING_INPUT_PENJUALAN } from "App/constants";
import { isNull } from "App/utils/helpers";
import { useDispatchWrapper } from "hooks";
import React, { createContext, useEffect, useState } from "react";
import { RESET_STATE_INPUT_PENJUALAN } from "../ui";
export const FormContext = createContext();

export const FormProvider = ({ children }) => {
  const { state } = useDispatchWrapper();

  const [formData, setFormData] = useState(() => {
    if (isNull(state.page_input_penjualan)) {
      return RESET_STATE_INPUT_PENJUALAN;
    } else {
      if (state.wrapper_active_menu === BILLING_INPUT_PENJUALAN) {
        return state.page_input_penjualan;
      } else {
        return RESET_STATE_INPUT_PENJUALAN;
      }
    }
  });

  useEffect(() => {
    if (isNull(state.page_input_penjualan)) {
      setFormData(RESET_STATE_INPUT_PENJUALAN);
    } else {
      if (state.wrapper_active_menu === BILLING_INPUT_PENJUALAN) {
        setFormData(state.page_input_penjualan);
      } else {
        setFormData(RESET_STATE_INPUT_PENJUALAN);
      }
    }
  }, [state.page_input_penjualan]);

  return (
    <FormContext.Provider value={{ formData, setFormData }}>
      {children}
    </FormContext.Provider>
  );
};
